import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Loading } from 'components/Loading';
import { selectData, selectYear } from 'store/selectors';

import { tableStyle } from './ReportStatus.style';

const groupByRole = (data) => {
  return data.reduce((acc, item) => {
    const role = item.Role || 'Unknown';
    if (!acc[role]) acc[role] = [];
    acc[role].push(item);
    return acc;
  }, {});
};

const DataTable = ({ data }) => {
  if (!data || data.length === 0) return <p>No data available.</p>;

  const allKeys = Object.keys(data[0]);
  const headers = [
    'Name',
    ...allKeys.filter(
      (key) => !['Name', 'Sum of Entries', 'Role'].includes(key),
    ),
    'Sum of Entries',
  ];

  const getRowColor = (sum) => {
    if (sum === 0) return '#f28b82';
    if (sum > 0 && sum < 10) return '#fff475';
    if (sum >= 10) return '#81c995';
    return 'inherit';
  };

  const groupedData = groupByRole(data);

  const roleOrder = ['Faculty', 'Post-doctoral Researcher', 'PhDStudent'];

  const sortedRoles = [
    ...roleOrder.filter((role) => groupedData[role]),
    ...Object.keys(groupedData).filter((role) => !roleOrder.includes(role)),
  ];

  return (
    <Box width="100%" display="flex" flexDirection="column" gap={4}>
      {sortedRoles.map((role) => (
        <Box key={role} width="100%">
          <Typography variant="h6" mb={1}>
            {role}
          </Typography>
          <TableContainer component={Paper} sx={tableStyle}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {headers.map((header, index) => (
                    <TableCell
                      key={header}
                      align={index === 0 ? 'left' : 'center'}>
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {groupedData[role].map((row, rowIndex) => {
                  const sum = row['Sum of Entries'];
                  return (
                    <TableRow
                      key={rowIndex}
                      sx={{ backgroundColor: getRowColor(sum) }}>
                      {headers.map((header, index) => (
                        <TableCell
                          key={header}
                          align={index === 0 ? 'left' : 'center'}>
                          {row[header]}
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ))}
    </Box>
  );
};

const ReportStatus = () => {
  const year = useSelector(selectYear);
  const data = useSelector(selectData);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Typography variant="h5">{year} Annual Report Status</Typography>
      {data === null ? <Loading /> : <DataTable data={data} />}
    </Box>
  );
};

export default ReportStatus;
